/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import {
    string, any, shape, number,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
    customWrapper: ({
        customsCard, imageParam, labelWidth, labelHeight,
    }) => ({
        borderRadius: '20px',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${customsCard}${imageParam})`,
        width: labelWidth,
        height: labelHeight,
        [theme.breakpoints.down('sm')]: {
            backgroundSize: '100% 100%',
        },
    }),
    customContentContainer: {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    customHangContainer: {
        marginLeft: '1.875rem',
        marginTop: '2.25rem',
        width: '312px',
        height: '210px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '1rem',
        },
    },
    contentWrapper: ({
        containerWidth, containerHeight, marginTop, marginLeft,
    }) => ({
        textAlign: 'center',
        width: containerWidth,
        height: containerHeight,
        marginTop,
        marginLeft,
    }),
}));

const CustomsCardWrapper = ({
    customsCard, children, customType, customData,
}) => {
    const {
        label_width, label_height, content_area_width, content_area_height,
    } = customData || {};
    const mobileResolution = useMediaQuery('(max-width: 600px)'); // for mobile resolution

    const calcDimension = (val) => (val * 72) / 300;
    const labelWidth = calcDimension(label_width > 1400 && mobileResolution ? (label_width / 2) : label_width);
    const labelHeight = calcDimension(label_height > 1000 && mobileResolution ? (label_height / 2) : label_height);
    const containerWidth = calcDimension(content_area_width > 1400 && mobileResolution ? (content_area_width / 2) : content_area_width);
    const containerHeight = calcDimension(content_area_height > 1000 && mobileResolution ? (content_area_height / 2) : content_area_height);
    const marginTop =  (labelHeight - containerHeight) / 2;
    const marginLeft =  (labelWidth - (containerWidth + 9)) / 2;
    const imageParam = `?width=${labelWidth}&height=${labelHeight}`;
    const classes = useStyles({
        customsCard, labelWidth, labelHeight, containerWidth, containerHeight, marginTop, marginLeft, imageParam,
    });

    const containerClass = customType === 'label' ? classes.customContentContainer : classes.customHangContainer;

    return (
        <Grid
            className={classes.customWrapper}
        >
            <Grid
                className={`${containerClass} ${classes.contentWrapper}`}
            >
                {children}
            </Grid>
        </Grid>
    );
};

CustomsCardWrapper.propTypes = {
    customsCard: string.isRequired,
    children: any,
    customType: string,
    customData: shape({
        content_area_width: number,
        content_area_height: number,
        message_image_settings: shape({
            image_width: number,
        }),
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
};

CustomsCardWrapper.defaultProps = {
    children: {},
    customType: '',
};
export default CustomsCardWrapper;
